import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {LangType, TranslationLangType} from "../common/enums/ContentEnum";

const logPrefix  = "[FAQStore]"
export const faqType = {
    question: {
        name:'question',
        value:0,
        text:''
    },
    answer:{
        name:'answer',
        value:1,
        text:''
    },
}
const defaultLangList = [...Object.values(LangType),...Object.values(TranslationLangType)].map(lang=>{
    return {
        faqId:0,
        question:'',
        answer:'',
        languageCode:lang,
        isEnable:'N',
    }
})
export default class FAQStore {

    constructor(props) {
        this.faqRepository = props.faqRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;
        this.faqs = [];
        this.rowsPerPage = 10;
        this.page = 0;

        this.faqContents = JSON.parse(JSON.stringify(defaultLangList));

        makeAutoObservable(this);
    }
    initFAQDetailInfo = () => {
        this.faqContents = JSON.parse(JSON.stringify(defaultLangList));
    }

    setRowsPerPage = (rowsPerPage) => {
        this.page = 0;
        this.rowsPerPage = rowsPerPage;
    }

    setPage = (page) => {
        this.page = page;
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    setFaqs = (data) => {
        this.faqs = data;
    }

    setFaqContents = async (data,callback) => {
        await this.faqContents.forEach((content,index)=>{
            if (data.length && data.length > 0) {
                data.forEach(datum=>{
                    if(content.languageCode === datum.languageCode) {
                        this.faqContents[index] = datum;
                    }
                })
            }
        })
        await callback && callback();
    }

    setFaqTranslations = async (lang,type,data,callback) => {
        await this.faqContents.forEach((content,index)=>{
            if (data.length && data.length > 0) {
                data.forEach(datum=>{
                    if( lang !== content.languageCode && content.languageCode === datum.lang) {
                        this.faqContents[index][type] = datum.translation;
                    }
                })
            }
        })
        await callback && callback();
    }

    controlAllFAQEnable = (enable) => {
        this.faqContents.forEach(faq => faq.isEnable = enable);
    }

    setFAQElement = (index,type,value) => {
        this.faqContents[index][type] = value;
        console.log(this.faqContents[index],this.faqContents[index][type])
    }

    get isAllFAQEnable () {
        return this.faqContents.every(faq => faq.isEnable === 'Y');
    }

    get isAllTranslationsFilled () {
        return this.areFAQContentFilled();
    }
    areFAQContentFilled = () => {
        return this.faqContents.every(content=>content.question.trim() && content.answer.trim());
    }

    getCurrentIndexWithLangCode = (languageCode) => {
        return this.faqContents.findIndex(faq=>faq.languageCode === languageCode);
    }

    * getFaqs(lang) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getFaqs.');
            const response = yield this.faqRepository.getFAQInfo(`?lang=${lang.toUpperCase()}`);
            this.setFaqs(response.data);
            console.log(logPrefix, 'Finished getFaqs.');
        } catch (e) {
            console.log(logPrefix, 'Failed getFaqs.');
            this.openErrorDialog({
                titleText: 'FAQ 그룹 목록 불러오기 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 목록을 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    *getFaqContents(faqId,callback){
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start getFaqContents.');
            const url = `contents?faq-id=${faqId}`
            const response = yield this.faqRepository.getFAQInfo(url);
            callback && callback(response.data,this.commonStore.initLoadingState);
            console.log(logPrefix, 'Finished getFaqContents.',response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getFaqContents.');
            this.openErrorDialog({
                titleText: 'FAQ 정보 불러오기 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 정보를 불러오는 도중 에러가 발생했습니다.')
            });
            this.commonStore.initLoadingState();
        } finally {
            // this.commonStore.initLoadingState();
        }
    }

    *updateFAQEnable(faqId,languageCode,isEnabled,callback){
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start getFaqContents.');
            const url = `enable`
            const param = {
                faqId: faqId,
                languageCode:languageCode,
                isEnable:isEnabled
            }
            yield this.faqRepository.putFAQInfo(url,param);
            callback && callback(languageCode,isEnabled);
        } catch (e) {
            console.log(logPrefix, 'Failed getFaqContents.');
            this.openErrorDialog({
                titleText: 'FAQ 앱 노출 여부 변경 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 앱 노출 여부 변경 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }
    *translateFAQ(index,targetLang,currentLang,text,type,callback){
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start translateFAQ.');
            const url = `translate?target-lang=${targetLang}&current-lang=${currentLang}&text=${text}`
            const response = yield this.faqRepository.getFAQInfo(url);
            console.log("response : ",response.data);
            callback && callback(index,type,response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed translateFAQ.');
            this.openErrorDialog({
                titleText: 'FAQ 번역 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 앱 변역 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }
    *translateAllFAQ(lang,text,type,callback){
        this.commonStore.setLoadingState('Translating...');
        try {
            console.log(logPrefix, 'Start translateAllFAQ.');
            const url = `translate/all?lang=${lang}&text=${text}`;
            const response = yield this.faqRepository.getFAQInfo(url);
            console.log("response : ",response.data);
            callback && callback(lang,type,response.data,this.commonStore.initLoadingState);
        } catch (e) {
            console.log(logPrefix, 'Failed translateAllFAQ.');
            this.openErrorDialog({
                titleText: 'FAQ 번역 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 앱 변역 도중 에러가 발생했습니다.')
            });
            this.commonStore.initLoadingState();
        }
    }

  *addFAQList(faqId,callback){
        this.commonStore.setLoadingState('Submitting...');
        try {
            console.log(logPrefix, 'Start addFAQList.');
            const url = ``;
            const param = {
                faqId:faqId,
                faqContent:this.faqContents
            }
            const response = yield this.faqRepository.putFAQInfo(url,param);
            console.log("response : ",response.data);
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed addFAQList.');
            this.openErrorDialog({
                titleText: 'FAQ 번역 작업 저장 오류',
                text: displayErrorDialogPrompt(e, 'FAQ 앱 변역 작업 저장 도중 에러가 발생했습니다.')
            });
        }  finally {
            this.commonStore.initLoadingState();
        }
    }

    * deleteFAQ(id, callback) {
        try {
            console.log(logPrefix, 'Start delete FAQ');
            yield this.faqRepository.deleteFAQInfo(id);
            console.log(logPrefix, 'Finished delete FAQ');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed delete FAQ');
        } finally {
            this.commonStore.initLoadingState();
        }
    }


}
